<template>
  <v-dialog
    :model-value="modelValue"
    transition="dialog-top-transition"
    max-width="480px"
    content-class="warning-dialog-position"
    @update:model-value="$emit('update:modelValue', $event)"
    @click:outside="onCancel"
  >
    <div class="warning-dialog pa-5">
      <div class="d-flex align-center mb-3">
        <v-icon color="error" size="28" class="mr-2">mdi-alert-circle</v-icon>
        <span class="text-h6 text-error font-weight-bold">Warning</span>
      </div>

      <div class="text-body-1 text-grey-darken-3 mb-4">
        {{ message }}
      </div>

      <div class="d-flex justify-end gap-2">
        <v-btn
          variant="outlined"
          @click="onCancel"
        >Cancel</v-btn>
        <v-btn
          color="error"
          @click="onConfirm"
        >Continue</v-btn>
      </div>
    </div>
  </v-dialog>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'WarningConfirmDialog',
  props: {
    modelValue: { type: Boolean, default: false },
    message: { type: String, default: '' },
  },
  emits: ['update:modelValue', 'confirm', 'cancel'],
  methods: {
    onConfirm() {
      this.$emit('confirm');
      this.$emit('update:modelValue', false);
    },
    onCancel() {
      this.$emit('cancel');
      this.$emit('update:modelValue', false);
    },
  },
});
</script>

<style scoped>
.warning-dialog {
  background-color: #FFF5F5;
  border-top: 4px solid #D32F2F;
  border-radius: 8px;
}
</style>

<style>
.warning-dialog-position {
  align-self: flex-start;
  margin-top: 48px;
}
</style>
